import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { usePlanItMechanicsQuery } from "modules/UsersDashboard/components/PairUsers/hooks/usePlanItMechanicsQuery";
import { useGetUsersDashboardFilters } from "modules/UsersDashboard/components/UsersDashboardFilters/hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { PlanItPlanningMechanic } from "models";
import type { PairedUserState } from "modules/UsersDashboard/components/PairUsers";

const constructPayload = (pairedUsers: PairedUserState[], planItMechanics: PlanItPlanningMechanic[] = []) =>
  pairedUsers.flatMap(({ pair_to, user_id }) => {
    const pairedUser = planItMechanics.find(planItMechanic => planItMechanic.planit_planning_mechanic_id === pair_to);
    return pairedUser ? { ...pairedUser, planit_user_id: user_id } : [];
  });

export const useUpdatePairPlanItUsersMutation = (pairedUsers: PairedUserState[]) => {
  const {
    filters: { dealer_location_ids }
  } = useGetUsersDashboardFilters();
  const { data: planItMechanics } = usePlanItMechanicsQuery(dealer_location_ids);

  return useTypedMutation<void, void>({
    mutationFn: async () =>
      (await ApiInstance.post("/users/pairing/planit/update", { planit_planning_mechanics: constructPayload(pairedUsers, planItMechanics) }, ENV.systemBaseURL)).data,
    onSuccess: () => {
      const prevUsers = typedQueryClient.getQueryData(UsersDashboardQueryKeys.users);
      if (!prevUsers) return;

      typedQueryClient.setQueryData(UsersDashboardQueryKeys.users, {
        ...prevUsers,
        users: prevUsers.users.map(user => {
          const paired = pairedUsers.find(pairedUser => pairedUser.user_id === user.id);
          return paired ? { ...user, planit_planning_mechanic_id: paired.pair_to ?? undefined } : user;
        })
      });
    }
  });
};
